var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, required: _vm.getRequire } },
    [
      _c("el-time-picker", {
        staticClass: "item",
        class: { require: _vm.getRequire && _vm.isNull() },
        attrs: {
          editable: false,
          size: "small",
          disabled: _vm.disabled,
          placeholder: "选择时间",
          format: _vm.format,
          "value-format": "HH:mm:ss",
        },
        on: { change: _vm.change },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }